export const DEFAULT_SVG_SIZE = 800; // Size of the SVG canvas
export const START_ANGLE = -Math.PI / 2; // Starting angle for the root node
export const ANGLE_PER_LEVEL = Math.PI / 4; // Angle between nodes at the same depth
export const KA_FACTOR = 1e3;
export const MA_FACTOR = 1e6;
export const GA_FACTOR = 1e9;
